import type { SxProps, Theme } from '@mui/material';

export const header: SxProps<Theme> = {
  py: 4,
  px: 3,
};

export const headerContainer: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const buttonContainer: SxProps<Theme> = {
  display: 'flex',
  gap: 2,
  alignItems: 'center',
};

export const copyButton: SxProps<Theme> = {
  backgroundColor: 'primary.main',
  color: 'primary.contrastText',
  textTransform: 'none',
  fontWeight: 500,
  '&:hover': {
    backgroundColor: 'primary.dark',
    cursor: 'pointer',
  },
};

// Sort dropdown FormControl styles - fixed width to accommodate longest label ("Alphabetical")
export const sortFormControl: SxProps<Theme> = {
  width: 180,
};

// Placeholder text style when no value is selected (default "Sort By" state)
export const sortPlaceholder: SxProps<Theme> = {
  color: 'text.secondary',
};
